import React, { useState, useEffect, Fragment } from "react";
import { Box, Card, Stack, responsiveFontSizes } from "@mui/material";
import { fetchRecepcion } from "verticales/FetchData";
import Tabs from "@mui/material/Tabs";
import MDBox from "components/MDBox";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CardContent from "@mui/material/CardContent";
import AppLoading from "verticales/AppLoading.tsx";
import { Label } from "recharts";
import { Backpack, FileDownload, Mail, Margin, Padding } from "@mui/icons-material";
import { json } from "react-router-dom";
import fetchData from "verticales/FetchData";

const url = "https://292br7ikz2.execute-api.us-east-1.amazonaws.com/st-fe-recepcion/recepcion/";
const action = "mail";
function DatosMail(props: any) {
  console.log(props.row.original);
  // console.log(props.row.original.id_mensaje);
  const [mailData, setMailData] = useState({});
  const [Attachment, setAttachment] = useState([]);
  const [blocking, setBlocking] = React.useState(true);
  const [documentUrl, setDocumentUrls] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const infoMail = async () => {
    // setBlocking(true);
    const params = {
      action: "mail",
      filename: props.row.original.id_mensaje,
    };

    const objMail = await fetchRecepcion(url, action, params);
    const mail = JSON.parse(objMail);
    console.log(mail);
    if (mail) {
      setMailData(mail);
      setAttachment(mail.Attachments);
    } else {
      console.log("La informacion no existe");
    }
    setBlocking(false);
  };

  useEffect(() => {
    infoMail();
  }, []);

  const getDocumentUrl = async (Document) => {
    setBlocking(true);
    const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
    const action = "fe-recepcion";
    // const urlDocument = {};

    for (const doc of Attachment) {
      if (doc == Document) {
        const params = {
          action: "get-url-presigned",
          object: {
            emailFrom: props.row.original.mail_from,
            idMessage: props.row.original.id_mensaje,
            attachment: doc,
          },
        };

        console.log(params);

        try {
          const getData = await fetchData(url, action, params);
          console.log(getData);
          window.open(getData.url, "_blank");
          setDocumentUrls(getData.url);
        } catch (er) {
          console.log("Error....", er);
        }
      }
    }
    setBlocking(false);
  };

  return (
    <DashboardLayout>
      <MDBox pt={4} pb={3} px={3} display="flex" justifyContent="center">
        <Grid>
          <Card
            sx={{
              width: "100",
              maxWidth: "90vw",
              maxHeight: "90vh",
              boxShadow: 3,
              borderRadius: 3,
            }}
          >
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={5}
              mt={-3}
              p={2}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="bold" color="white" mt={1}>
                Detalle de correo
              </MDTypography>
            </MDBox>
            {blocking ? (
              <AppLoading titleCustom={"Detalle mail"} />
            ) : (
              <Grid
                p={3}
                pl={5}
                pr={5}
                item
                xs={12}
                sm={10}
                md={8}
                lg={6}
                xl={4}
                sx={{
                  width: "100%",
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  fontSize: "18px",
                  overflow: "auto",
                }}
              >
                <Grid item xs={12} ml={-2}>
                  <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                    <b>Fecha:</b> <br />
                    {mailData.Date || "No disponible"}
                  </MDBox>
                </Grid>
                <Grid item xs={12} ml={-2}>
                  <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                    <b>Id Mensaje:</b> <br />
                    {props.row.original.id_mensaje}
                  </MDBox>
                </Grid>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} pt={2}>
                  <Grid item xs={6} ml={-2}>
                    <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                      <b>Remitente:</b> <br />
                      {mailData.From || "No disponible"}
                    </MDBox>
                  </Grid>
                  <Grid item xs={6} ml={-5}>
                    <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                      <b>Destinatario:</b> <br />
                      {mailData.To || "No disponible"}
                    </MDBox>
                  </Grid>
                </Grid>
                <Grid item xs={12} ml={-2}>
                  <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                    <b>Asunto:</b> <br />
                    {mailData.Subject || "No disponible"}
                  </MDBox>
                </Grid>
                <Grid item xs={12} sm={10} md={8} lg={6} xl={4} ml={-2} sx={{ fontSize: "18px" }}>
                  <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                    <b>Adjuntos:</b>
                    <br />
                    {Attachment && Attachment.length > 0 ? (
                      Attachment.map((Document, index) => (
                        <Box key={index} display="flex" alignItems="center" mt={1}>
                          <MDTypography
                            ml={1}
                            color="info"
                            component="a"
                            onClick={(e) => {
                              e.preventDefault();
                              getDocumentUrl(Document);
                            }}
                            href={documentUrl}
                            download
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "calc(100% - 30px)",
                              display: "inline-block",
                              textDecoration: "none",
                            }}
                          >
                            {Document}
                          </MDTypography>
                        </Box>
                      ))
                    ) : (
                      <Grid item xs={12}>
                        <MDBox borderRadius={2} bgcolor="grey.100">
                          Sin adjunto
                        </MDBox>
                      </Grid>
                    )}
                  </MDBox>
                </Grid>
              </Grid>
            )}
            {/* <CardContent sx={{ bgcolor: "grey.200", textAlign: "center", p: 2 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Información detallada de los correos que llegan por recepción
              </Typography>
            </CardContent> */}

            <Stack justifyContent="flex-end" direction="row" sx={{ p: 2 }}>
              <MDButton variant="contained" color="info" onClick={props.handleCloseModal}>
                Aceptar
              </MDButton>
            </Stack>
          </Card>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DatosMail;
